import { render, staticRenderFns } from "./LawAuthorityCategoryList.vue?vue&type=template&id=5bb9aa44&"
import script from "./LawAuthorityCategoryList.vue?vue&type=script&lang=js&"
export * from "./LawAuthorityCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./LawAuthorityCategoryList.vue?vue&type=style&index=0&id=5bb9aa44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports